import Image from 'next/image'

export type UiIconProps = {
  name: string
  w?: number
  h?: number
  color?: string
  style?: React.CSSProperties
  ariaHidden?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const UI_ICONS: { [key: string]: string } = {
  add_circle: '/embedded/icons/ui_icons/add_circle.svg',
  add: '/embedded/icons/ui_icons/add.svg',
  arrow_back: '/embedded/icons/ui_icons/arrow_back.svg',
  arrow_drop_down: '/embedded/icons/ui_icons/arrow_drop_down.svg',
  big_check: '/embedded/icons/ui_icons/big_check.svg',
  calendar_month: '/embedded/icons/ui_icons/calendar_month.svg',
  checkbox: '/embedded/icons/ui_icons/checkbox.svg',
  checkbox_checked: '/embedded/icons/ui_icons/checkbox_checked.svg',
  check_circle_filled: '/embedded/icons/ui_icons/check_circle_filled.svg',
  chevron: '/embedded/icons/ui_icons/chevron.svg',
  chevron_left: '/embedded/icons/ui_icons/chevron_left.svg',
  close: '/embedded/icons/ui_icons/close.svg',
  error: '/embedded/icons/ui_icons/error.svg',
  hide: '/embedded/icons/ui_icons/hide.svg',
  info: '/embedded/icons/ui_icons/info.svg',
  search: '/embedded/icons/ui_icons/search.svg',
  eye: '/embedded/icons/ui_icons/eye.svg',
  eye_off: '/embedded/icons/ui_icons/eye_off.svg',
  clear: '/embedded/icons/ui_icons/clear.svg',
  lightning_bolt: '/embedded/icons/ui_icons/lightning_bolt.svg',
  link: '/embedded/icons/ui_icons/link.svg',
  rounded_arrow_up: '/embedded/icons/ui_icons/rounded_arrow_up.svg',
  rounded_arrow_down: '/embedded/icons/ui_icons/rounded_arrow_down.svg',
  shield: '/embedded/icons/ui_icons/shield.svg',
  social_text: '/embedded/icons/ui_icons/social_text.svg',
  social_email: '/embedded/icons/ui_icons/social_email.svg',
  social_facebook: '/embedded/icons/ui_icons/social_facebook.svg',
  social_linkedin: '/embedded/icons/ui_icons/social_linkedin.svg',
  social_x: '/embedded/icons/ui_icons/social_x.svg',
  visibility: '/embedded/icons/ui_icons/visibility.svg',
  visibility_off: '/embedded/icons/ui_icons/visibility_off.svg',
}

export const UiIcon = ({
  name,
  color = '#1A1919',
  w = 24,
  h = 24,
  ariaHidden = false,
  style,
}: UiIconProps) => (
  <Image
    alt={name}
    src={UI_ICONS[name]}
    aria-hidden={ariaHidden}
    style={{ fill: color, width: `${w}px`, height: `${h}px`, ...style }}
    height={h}
    width={w}
  />
)
